import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';

import { DropdownChangeEvent } from 'primeng/dropdown';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-additional-data-second',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './additional-data-second.component.html',
    styleUrl: './additional-data-second.component.scss',
})
export class AdditionalDataSecondComponent {

	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    additionalDataTitle = 'features.additionalData.additionalDataTitle';
    additionalDataSubtitle = 'features.additionalData.additionalDataSubtitle';
    infoYear = 'features.additionalData.additionalDataSecond.infoYear';
    yearDrop = 'features.additionalData.additionalDataSecond.yearDrop';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    situationOptions: LabelCode[] = [];
    selectedYear: any;
    selectedYears: LabelCode[] = [];
    yearList: LabelCode[] = [];

    year: number = new Date().getFullYear();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(11);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.generateYearList();
        this.getYears();

        this.createForm();
        this.setValuesForm(this.appData.data.userData.additionalDataSecond);
        this.formIsValid();
    }

    generateYearList() {
        const startYear = this.year - 80;
        this.yearList = Array.from({ length: this.year - startYear + 1 }, (_, index) => ({
            label: `${startYear + index}`,
            code: `${startYear + index}`,
        }));
    }

    createForm() {
        this.selectedYear = null;

        this.formGroup = this.fb.group({
            year: new FormControl(this.selectedYear ? this.selectedYear.code : '', [Validators.required]),
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.selectedYear = this.findYear(value.year.code);
            this.formGroup = this.fb.group({
                year: new FormControl(this.selectedYear ? this.selectedYear : '', [Validators.required])
            });
        }
    }

    findYear(year : string) {
        return this.yearList.find(yearL => yearL.code === year);
    }

    //-------------------------//
    //----------GET-----------//
    //-------------------------//

    getYears(value: any = undefined) {
        this.selectedYears = [];

        let i = 0;
        while (i < this.yearList.length) {
            let item: LabelCode = {
                label: '' + this.yearList[i].label + '',
                code: '' + this.yearList[i].code + '',
            };

            this.selectedYears.push(item);
            i++;
        }

        this.selectedYears.forEach((item) => {
            this.selectedYear = item;
        });
    }

    //-------------------------//
    //--------ON CHANGE-------//
    //-------------------------//

    onChangeYear(event: DropdownChangeEvent) {
        this.selectedYear = event.value;
        this.formGroup.controls['year'].patchValue(this.selectedYear);
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-second');
        this.router.navigate(['/main/step/additional-data-first'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-second');
        this.router.navigate(['/main/step/additional-data-loan'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
